var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSkelton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "168px",
    height: "98px",
    viewBox: "0 0 168 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-2.7%",
    width: "109.5%",
    height: "111.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    "in": "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 19,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.166044337   0 0 0 0 0.255166748   0 0 0 0 0.522534014  0 0 0 0.405966938 0",
    type: "matrix",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-35.4%",
    width: "136.7%",
    height: "169.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.386769877   0 0 0 0 0.472897645   0 0 0 0 0.685427296  0 0 0 0.23547894 0",
    type: "matrix",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 77.9813879,
    height: 147.499027,
    rx: 2.15418199
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.91808757%",
    y1: "50%",
    x2: "96.6726075%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62B2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Day-886-Not-Supported-Screen-Size-UI-Design",
    transform: "translate(-716.000000, -498.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    x: 1,
    y: 1,
    width: 1600,
    height: 1200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(481.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(144.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.5,
    fill: "#f7f9fc",
    fillRule: "nonzero",
    cx: 113,
    cy: 113,
    r: 113
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-4)",
    transform: "translate(38.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(75.411125, 39.409437) rotate(-90.000000) translate(-75.411125, -39.409437) translate(36.146419, -34.762786)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    mask: "url(#mask-6)",
    fill: "#ECECF2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.648438, 37.732309)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 42.6528033,
    y: 0,
    width: 6.03170956,
    height: 96.9034306,
    rx: 2.15418199
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 28.4352022,
    y: 0,
    width: 6.03170956,
    height: 53.5970302,
    rx: 2.15418199
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 14.2176011,
    y: 0,
    width: 6.03170956,
    height: 72.4631848,
    rx: 2.15418199
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 0,
    width: 6.03170956,
    height: 90.9005632,
    rx: 2.15418199
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#614FE6",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    x: 0,
    y: 0,
    width: 77.9813879,
    height: 30.0143369
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSkelton);
export default __webpack_public_path__ + "static/media/message-skelton.97f2533c.svg";
export { ForwardRef as ReactComponent };